<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 2.85185L9.14815 1L1.74074 8.40741L1 11L3.59259 10.2593L11 2.85185ZM7.66667 2.48148L9.51852 4.33333L7.66667 2.48148ZM1.74074 8.40741L3.59259 10.2593L1.74074 8.40741Z" stroke="url(#paint0_linear)" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear" x1="6" y1="1" x2="6" y2="11" gradientUnits="userSpaceOnUse">
        <stop stop-color="$mainGreen"/>
        <stop offset="1" stop-color="$mainGreen"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>